import { Asset } from '../../assets';
import { Audit } from '../../auth';
import { IssueCreationSource, IssueType, Severity } from '../../graphql';
import { Label } from '../../labels';
import { Location } from '../../location';
import { AssetRoutine, WorkspaceRoutine } from '../../routine';
import { Workspace } from '../../workspace';

export interface Issue extends Audit {
  id: string;
  severity: Severity;
  title: string;
  type: IssueType;
  asset: Asset;
  workspace: Workspace;
  routineVersion?: WorkspaceRoutine;
  /**
   * The submission behind a routine-backed Activity. `getIssue` fetches it
   * (id/data/routineVersion/…) so the revise/edit entry points can read
   * `data.idp.status` without a second query — see
   * `useIsAssetRoutineIdpInProgress`.
   */
  assetRoutine?: AssetRoutine;
  location?: Location;
  createdFrom?: IssueCreationSource;
  createdFromAddress?: string;
  adjustCreationDate?: string;
  effectiveCreationDate?: string;
  isPinned?: boolean;
  labels?: Label[];
}
